enum GUTTER_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA_LARGE = 'extra-large',
}

enum GUTTER_SIZE_PX {
  SMALL = 12,
  MEDIUM = 16,
  LARGE = 18,
  EXTRA_LARGE = 24,
}

export { GUTTER_SIZE, GUTTER_SIZE_PX };
